module.exports = __webpack_public_path__ + "static/media/dot_FFA200_a.2009c6e6.svg";